import { Capacitor } from "@capacitor/core";
import type { GpgsPort } from "@yjsgames/gpgs-ports";
import { NoopGpgsAdapter } from "@yjsgames/gpgs-ports";

/**
 * GpgsPort 결정(DIP 플랫폼 분기 팩토리, `createPaymentProvider`와 동형).
 * - 네이티브 Android: `CapacitorGpgsAdapter`(PGS v2 브리지). 플러그인 import는 동적 — 웹 번들에서 제외.
 * - 그 외(웹/iOS): `NoopGpgsAdapter`(무동작). GPGS는 Android 전용.
 *
 * 네이티브 어댑터는 dynamic import로 교체(결제/광고 패턴) — 준비 전까지 Noop로 동작하다 onReady로 통지.
 */
export interface CreateGpgsConfig {
  /** 네이티브 어댑터 로드 완료 시 통지 — 호출자가 교체 보관(부팅 signIn 재호출 등). 선택. */
  readonly onNativeReady?: (port: GpgsPort) => void;
}

export function createGpgs(config: CreateGpgsConfig = {}): GpgsPort {
  const fallback = new NoopGpgsAdapter();
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android") {
    void Promise.all([
      import("./CapacitorGpgsAdapter.js"),
      import("./capacitorGpgsPlugin.js"),
    ]).then(([{ CapacitorGpgsAdapter }, { GpgsNative }]) => {
      config.onNativeReady?.(new CapacitorGpgsAdapter(GpgsNative));
    });
  }
  return fallback;
}
